import { render, staticRenderFns } from "./MaterialIndexAdd.vue?vue&type=template&id=42708ac6"
import script from "./MaterialIndexAdd.vue?vue&type=script&lang=js"
export * from "./MaterialIndexAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports